var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coin3d"},[_c('div',{ref:"coinface",staticClass:"coin3d__coinface",class:{global: _vm.globalPosition}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }